import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"

const content_type = "sApproveUserSetting"

const create = function () {
  return {
    content_type: "muji"
  }
}
const type_fields = [{
  key: "id",
  label: "编号",
  type: "button",
  button: {
    type: "text"
  },
  thStyle: {
    width: "60px"
  }
},
{
  key: "DocumentType",
  label: "类型名称",
  sortable: true
},

{
  key: "ApproveType",
  label: "审批类型",
  sortable: true
},
{
  key: "ApproveLevel",
  label: "审批等级",
  sortable: true
},
{
  key: "is_approved",
  label: "审批状态",
  type: "boolean",
  thStyle: {
    display: "none"
  },
  tdClass: "no-shown-RetailVariantId"
},
{
  key: "description",
  label: "备注",
  sortable: true
},
]
const fields = [{
  key: "id",
  label: "编号",
  type: "button",
  button: {
    type: "text"
  },
  thStyle: {
    width: "60px"
  }
},
{
  key: "ApproveTypeSettingId",
  label: "审批类型编号",
  sortable: true
},
{
  key: "description",
  label: "说明",
  sortable: true,
  thStyle: {
    width: "8rem"
  }
},
{
  key: "DocumentCreateBy",
  label: "发起人",
  sortable: true
},
{
  key: "ApproveLevel",
  label: "审批等级",
  sortable: true
},
{
  key: "Approver",
  label: "审批人/角色",
},
{
  key: "isRole",
  label: "是否角色",
  type: "boolean"
},
{
  key: "ApproveRule",
  label: "审批规则",
},
{
  key: "dataAreaId",
  label: "公司"
},
{
  key: "is_valid",
  label: "是否启用",
  type: "boolean"
},

]

const dataForm = {
  id: 0,
  ApproveTypeSettingId: "",
  DocumentCreateBy: "",
  ApproveLevel: 1,
  Approver: "",
  isRole: false,
  ApproveRule: "",
  is_valid: true,
  dataAreaId: null,
}

///前端验证
const rules = {
  ApproveTypeSettingId: [{
    required: true,
    message: "请选择审批类型",
    trigger: "blur"
  }],
  ApproveLevel: [{
    required: true,
    message: "请选择审批等级",
    trigger: "blur"
  }],
}

const descriptor = {}

const methods = {
  async getTypeData(_params) {
    const type_biz_data = new biz_data_helper.base_entity_helper(
      "sApproveTypeSetting",
      create,
      descriptor
    )
    let result = await type_biz_data
      .selectAction({
        params: {
          id: {
            ">": 0
          }
        },
        fields: _.map(type_fields, "key")
      })
      .run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  //remove
  async RemoveData(items) {
    let _actions = []
    _.each(items, t => {
      _actions.push(
        biz_data
          .removeAction({
            params: {
              id: t.id
            }
          })
          .action({})
      )
    })
    let result = await api.query_batch({
      actions: _actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions[0].Result &&
      result.data.BatchResult.Actions[0].Result.Data &&
      result.data.BatchResult.Actions[0].Result.Data.length > 0
    ) {
      return true
    } else {
      return false
    }
  },
  ///update
  async upData(_data) {
    let datas = _data.selected_items
    let _actions = []
    switch (_data.state) {
      case "valid":
        //启用
        for (var i in datas) {
          datas[i].is_valid = true
        }
        break
      case "invalid":
        for (var i in datas) {
          datas[i].is_valid = false
        }
        //禁用
        break
      default:
        break
    }
    if (datas.length > 0) {
      _.each(datas, t => {
        let _data1 = {}
        if (_data.state) {
          if (_data.state == "valid" || _data.state == "invalid") {
            _data1.id = t.id
            _data1.ApproveTypeSettingId = t.ApproveTypeSettingId
            _data1.DocumentCreateBy = t.DocumentCreateBy
            _data1.ApproveLevel = t.ApproveLevel
            _data1.Approver = t.Approver
            _data1.isRole = t.isRole
            _data1.ApproveRule = t.ApproveRule == "" ? null : t.ApproveRule
            _data1.is_valid = _data.state == "valid" ? true : false
            _data1.dataAreaId = t.dataAreaId == "" ? null : t.dataAreaId
            _actions.push(
              biz_data
                .updateAction({
                  params: _data1,
                  fields: _.map(fields, "key")
                })
                .action({})
            )
          }
        } else {
          if (t.id == 0) {
            _data1.ApproveTypeSettingId = t.ApproveTypeSettingId
            _data1.DocumentCreateBy = t.DocumentCreateBy
            _data1.ApproveLevel = t.ApproveLevel
            _data1.Approver = t.Approver
            _data1.isRole = t.isRole
            _data1.ApproveRule = t.ApproveRule == "" ? null : t.ApproveRule
            _data1.is_valid = t.is_valid
            _data1.dataAreaId = t.dataAreaId == "" ? null : t.dataAreaId
            _actions.push(
              biz_data
                .insertAction({
                  params: _data1,
                  fields: _.map(fields, "key")
                })
                .action({})
            )
          } else {
            _data1.id = t.id
            _data1.ApproveTypeSettingId = t.ApproveTypeSettingId
            _data1.DocumentCreateBy = t.DocumentCreateBy
            _data1.ApproveLevel = t.ApproveLevel
            _data1.Approver = t.Approver
            _data1.isRole = t.isRole
            _data1.ApproveRule = t.ApproveRule == "" ? null : t.ApproveRule
            _data1.is_valid = t.is_valid
            _data1.dataAreaId = t.dataAreaId == "" ? null : t.dataAreaId
            _actions.push(
              biz_data
                .updateAction({
                  params: _data1,
                  fields: _.map(fields, "key")
                })
                .action({})
            )
          }
        }
      })
      let result = await api.query_batch({
        actions: _actions
      })
      if (
        result &&
        result.data &&
        result.data.BatchResult &&
        result.data.BatchResult.Actions &&
        result.data.BatchResult.Actions.length > 0
      ) {
        return result.data.BatchResult.Actions
      } else {
        return null
      }
    }

  },
  ///获取用户审批类型的审批人（不包括规则）
  async getUserDocumentApprover(_params) {
    const code_biz_data = new biz_data_helper.base_entity_helper("get_user_docutment_approver", {}, {})
    let _fields = []

    let result = await code_biz_data
      .execAction({
        params: _params,
        fields: _fields
      }).run()
    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  }
}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)
export {
  biz_data, dataForm, fields, methods,
  rules, type_fields
};

